<div class="table-outer-wrapper" [ngClass]="'table-' + uniqueId">
  <!-- Header: Scrolls horizontally with body, but stays fixed vertically -->
  <div class="header-container" #headerContainer
       [tableColumnManager]="uniqueId"
       [defaultWidths]="defaultWidths"
       [columnGroups]="columnGroups"
       [settings]="settings"
       (settingsChange)="onSettingsChange.emit($event)">
    <div class="table-inner-wrapper">
      <div class="routes-table-list-container">
        <div class="tr sticky-header">
          <!-- Merged header for drag, checkbox, and ID -->
          <div class="th col-name sticky-col" translate>
            Route
            <app-table-column-insert-button></app-table-column-insert-button>
          </div>

          @if (settings?.columns?.id) {
            <div class="th col-route-id" translate>
              ID
              <app-table-column-insert-button column="id"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.status) {
            <div class="th col-status" translate>
              Status
              <app-table-column-insert-button column="status"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.agent) {
            <div class="th col-agent" translate>
              Agent
              <app-table-column-insert-button column="agent"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.vehicle) {
            <div class="th col-vehicle" translate>
              Vehicle
              <app-table-column-insert-button column="vehicle"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.timeWindow) {
            <div class="th col-time-window" translate>
              Time Window
              <app-table-column-insert-button column="timeWindow"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.duration) {
            <div class="th col-duration" translate>
              Duration
              <app-table-column-insert-button column="duration"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.distance) {
            <div class="th col-distance" translate>
              Distance
              <app-table-column-insert-button column="distance"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.jobsCount) {
            <div class="th col-jobs-count" translate>
              Services
              <app-table-column-insert-button column="jobsCount"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.activitiesCount) {
            <div class="th col-activities-count" translate>
              Stops
              <app-table-column-insert-button column="activitiesCount"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.accounts) {
            <div class="th col-accounts" translate>
              Accounts
              <app-table-column-insert-button column="accounts"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.accountExternalId) {
            <div class="th col-account-ext-id" translate>
              Account External ID
              <app-table-column-insert-button column="accountExternalId"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.pickingHour) {
            <div class="th col-picking-hour" translate>
              Picking Hour
              <app-table-column-insert-button column="pickingHour"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.carrier) {
            <div class="th col-carrier" translate>
              Carrier
              <app-table-column-insert-button column="carrier"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.skills) {
            <div class="th col-skills" translate>
              Skills
              <app-table-column-insert-button column="skills"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.labels) {
            <div class="th col-labels" translate>
              Labels
              <app-table-column-insert-button column="labels"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.income) {
            <div class="th col-income" translate>
              Income
              <app-table-column-insert-button column="income"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.columns?.value) {
            <div class="th col-value" translate>
              Value
              <app-table-column-insert-button column="value"></app-table-column-insert-button>
            </div>
          }

          <!-- Load Columns -->
          @if (settings?.load?.weight) {
            <div class="th col-load col-load-weight" translate>
              Weight
              <app-table-column-insert-button column="weight" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.volume) {
            <div class="th col-load col-load-volume" translate>
              Volume
              <app-table-column-insert-button column="volume" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.packages) {
            <div class="th col-load col-load-packages" translate>
              Packages
              <app-table-column-insert-button column="packages" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.value) {
            <div class="th col-load col-load-value" translate>
              Value
              <app-table-column-insert-button column="value" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.pallets) {
            <div class="th col-load col-load-pallets" translate>
              Pallets
              <app-table-column-insert-button column="pallets" group="load"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.load?.spots) {
            <div class="th col-load col-load-spots" translate>
              Spots
              <app-table-column-insert-button column="spots" group="load"></app-table-column-insert-button>
            </div>
          }

          <!-- Capacity Columns -->
          @if (settings?.capacity?.weight) {
            <div class="th col-capacity col-capacity-weight" translate>
              Weight %
              <app-table-column-insert-button column="weight" group="capacity"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.capacity?.volume) {
            <div class="th col-capacity col-capacity-volume" translate>
              Volume %
              <app-table-column-insert-button column="volume" group="capacity"></app-table-column-insert-button>
            </div>
          }
          @if (settings?.capacity?.pallets) {
            <div class="th col-capacity col-capacity-pallets" translate>
              Pallets %
              <app-table-column-insert-button column="pallets" group="capacity"></app-table-column-insert-button>
            </div>
          }

          <!-- Action Columns -->
          <div class="td col-actions gap-5 sticky-col sticky-col-right" style="background: none"></div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!routes" class="flex layout-row layout-align-center-center padding-20">
    <div class="spinner-border" role="status"></div>
  </div>

  <div *ngIf="!!routes && !routes?.length" class="flex layout-column layout-align-center-center padding-20 empty-drop-zone full-height"
       cdkDropList
       [id]="dropListId || (panel.id + '_routes')"
       [cdkDropListData]="routes"
       [cdkDropListConnectedTo]="connectedPanelIds"
       [cdkDropListSortingDisabled]="dropListSortingDisabled"
       (cdkDropListDropped)="onListDrop.emit($event)"
       (cdkDropListEntered)="hovered = true"
       (cdkDropListExited)="hovered = false">
    <app-empty-state *ngIf="!hovered || !emptyDropText" src="assets/images/empty_state/empty_state_routes.png" text="No Routes Found"></app-empty-state>
    <div *ngIf="hovered && emptyDropText" class="flex-100 full-height layout-row layout-align-center-center padding-20">
      <h1 class="br-head-2 font-weight-600" translate>{{ emptyDropText }}</h1>
    </div>
  </div>

  <!-- Body: Handles vertical scrolling and horizontal scrolling -->
  <cdk-virtual-scroll-viewport *ngIf="!!routes && !!routes?.length"
                               class="body-container"
                               [itemSize]="32"
                               #bodyContainer
                               (scroll)="onBodyScroll($event)"
                               cdkDropList
                               [id]="dropListId || (panel.id + '_routes')"
                               [cdkDropListData]="routes"
                               [cdkDropListConnectedTo]="connectedPanelIds"
                               [cdkDropListSortingDisabled]="dropListSortingDisabled"
                               (cdkDropListDropped)="onListDrop.emit($event)">

    <div class="table-inner-wrapper">

      <div class="routes-table-list-container">

        <ng-container>
          <div *cdkVirtualFor="let route of routes; trackBy: trackByRouteId"
               class="tr"
               [ngClass]="{
                 'selected': selectedKeys[route.id],
                 'locked': route.locked
               }"
               (click)="onRowClick(route, bodyContainer.measureScrollOffset())"
               (dblclick)="onRowDoubleClick(route, bodyContainer.measureScrollOffset())"
               cdkDropList
               [id]="route.id"
               [cdkDropListConnectedTo]="connectedPanelIds"
               [cdkDropListSortingDisabled]="true"
               [cdkDropListEnterPredicate]="rowDropEnterPredicate"
               (cdkDropListDropped)="onDrop(route, $event)"
               cdkDrag
               [cdkDragData]="route"
               [cdkDragDisabled]="route.locked">

            <!-- Drag Preview -->
            <div *cdkDragPreview class="tr drag-preview routes-table-drag-preview">
              <div class="td col-name">
                {{ route.name ? route.name : 'Route' | translate }} {{ route.resource?.allocationName || route.resource?.vehicleName }}
              </div>
              <div class="td col-jobs-count">
                {{ route.jobIds?.length }} {{'Services' | translate}}
              </div>
            </div>

            <!-- Placeholder -->
            <div *cdkDragPlaceholder class="tr drag-placeholder"></div>

            <!-- Merged Sticky Column: Drag Handle + Checkbox + Eye + ID/Name -->
            <div class="td col-name sticky-col">
              <div class="layout-row layout-align-start-center gap-2">
                <div cdkDragHandle class="layout-row layout-align-start-center" (click)="$event.stopPropagation()">
                  <bringoz-icon iconName="drag" class="secondary-100 pointer"></bringoz-icon>
                </div>

                <app-planning-route-action-menu
                  [route]="route"
                  (onDispatch)="onDispatch.emit($event)"
                  (onReoptimize)="onReoptimize.emit($event)"
                  (onPreAssignAgent)="onPreAssignAgent.emit($event)"
                  (onPrint)="onPrint.emit($event)"
                  (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"
                  (onDelete)="onDelete.emit($event)"
                  (onFeedback)="onFeedback.emit($event)">
                </app-planning-route-action-menu>

                <app-bringoz-checkbox [isChecked]="selectedKeys[route.id]"
                                      (clickEvent)="onToggleSelectedRoute(route.id, !selectedKeys[route.id]); $event.stopPropagation()"
                                      (click)="$event.stopPropagation()">
                </app-bringoz-checkbox>

                <bringoz-button type="tertiary" size="fit" (onClick)="onToggleVisibleRoute(route.id, !visibleKeys[route.id]); $event.stopPropagation()" (click)="$event.stopPropagation()">
                  <bringoz-icon [iconName]="visibleKeys[route.id] ? 'eye-on' : 'eye-off'" classSize="lg" fill="#484848"></bringoz-icon>
                </bringoz-button>

                <bringoz-button *ngIf="!routeUiDataMap[route.id]?.isRunning"
                                type="tertiary"
                                size="fit"
                                (onClick)="onLockRouteChange.emit({id: route.id, locked: !route.locked}); $event.stopPropagation()"
                                (click)="$event.stopPropagation()">
                  <bringoz-icon [iconName]="route.locked ? 'lock' : 'lock-open-outline'" classSize="lg" fill="#484848"></bringoz-icon>
                </bringoz-button>

                <ng-container *ngIf="(!route.locked && !routeUiDataMap[route.id]?.isRunning) && route.status !== 'DISPATCHED'">
                  <bringoz-button type="tertiary"
                                  size="fit"
                                  *ngxPermissionsOnly="'planning.update'"
                                  (onClick)="onEditResourceAllocationClick(route, $event); $event.stopPropagation()"
                                  (click)="$event.stopPropagation()"
                                  [ngbTooltip]="'Edit Resource Allocation' | translate"
                                  openDelay="300"
                                  container="body">
                    <bringoz-icon iconName="edit-outline" classSize="sm" fill="#484848"></bringoz-icon>
                  </bringoz-button>
                </ng-container>

                <bringoz-icon *ngIf="route.jobChangesSyncedAt"
                              iconName="synced"
                              classSize="md"
                              [ngbTooltip]="('Synced' | translate) + ': ' + (route | bringozFullDate: 'jobChangesSyncedAt') + ' ' + (route | bringozTime: 'jobChangesSyncedAt')"
                              openDelay="300">
                </bringoz-icon>

                <div class="index-border" [style.background-color]="routeUiDataMap[route.id]?.color"></div>
              </div>

              <div class="route-name flex layout-row clickable gap-5 text-ellipsis"
                   (click)="onChangeRouteResourceClick(route.id, $event); $event.stopPropagation()">
                <span class="flex br-body-1 text-ellipsis font-weight-600"
                      [appBringozTooltip]="(route.name ? route.name : 'Route' | translate) + ' - ' + (route.resource?.allocationName || route.resource?.vehicleName)"
                      ngbTooltip>
                  {{ route.name ? route.name : 'Route' | translate }} {{ route.resource?.allocationName || route.resource?.vehicleName }}
                </span>
                <span id="route-resource-arrow">▾</span>
              </div>
            </div>

            <div *ngIf="settings?.columns?.id" class="td col-route-id">
              <div class="flex layout-row"
                   (mouseenter)="isShowCopyBtn=true"
                   (mouseleave)="isShowCopyBtn=false">
                <span class="br-body-1 text-ellipsis">{{ route.id }}</span>
                <app-text-copy-button [isShowCopyBtn]="isShowCopyBtn"
                                      [text]="route.id">
                </app-text-copy-button>
              </div>
            </div>

            <div *ngIf="settings?.columns?.status" class="td col-status gap-5">
              <app-bringoz-status-tag [status]="routeUiDataMap[route.id]?.isRunning ? (route.actionProcess.isDispatching ? 'DISPATCHING' : 'OPTIMIZING') : route.status"></app-bringoz-status-tag>
            </div>

            <div *ngIf="settings?.columns?.agent" class="td col-agent gap-5">
              <bringoz-icon iconName="agent" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.resource?.agentName || '---' }}</span>
            </div>

            <div *ngIf="settings?.columns?.vehicle" class="td col-vehicle gap-5">
              <bringoz-icon [iconName]="route.resource?.vehicleClass?.toLowerCase()" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ logisticsVehicleNameByResourceId[route.resourceId] || route.resource?.vehicleName || '---' }}</span>
            </div>

            <div *ngIf="settings?.columns?.timeWindow" class="td col-time-window gap-5">
              <bringoz-icon iconName="time-window-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ routeUiDataMap[route.id]?.dateRange | timeWindow }}</span>
            </div>

            <div *ngIf="settings?.columns?.duration" class="td col-duration gap-5">
              <bringoz-icon iconName="timer-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.totalTimeSec | bringozTimeConvert }}</span>
            </div>

            <div *ngIf="settings?.columns?.distance" class="td col-distance gap-5">
              <bringoz-icon iconName="distance" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.totalDistanceMeter | bringozDistance:'---':true }}</span>
            </div>

            <div *ngIf="settings?.columns?.jobsCount" class="td col-jobs-count gap-5">
              <bringoz-icon iconName="package-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.jobIds?.length }}</span>
              <bringoz-icon *ngIf="route.jobChangesSyncedAt"
                            iconName="synced"
                            classSize="sm"
                            [ngbTooltip]="('Synced' | translate) + ': ' + (route | bringozFullDate: 'jobChangesSyncedAt') + ' ' + (route | bringozTime: 'jobChangesSyncedAt')"
                            openDelay="300">
              </bringoz-icon>
            </div>

            <div *ngIf="settings?.columns?.activitiesCount" class="td col-activities-count gap-5">
              <bringoz-icon iconName="location-pin-outline" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.totalStopsCount }}</span>
            </div>

            <div *ngIf="settings?.columns?.accounts" class="td col-accounts gap-5">
              <bringoz-icon iconName="account" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis clickable" [ngbTooltip]="accountsTooltip"
                    tooltipClass="planning-draft-routes-table-list-accounts-tooltip"
                    container="body" (click)="$event.stopPropagation()">
                {{ routeUiDataMap[route.id]?.accountIds.length === 1 ? ('X_ACCOUNT' | translate: {length: routeUiDataMap[route.id]?.accountIds.length}) : ('X_ACCOUNTS' | translate: {length: routeUiDataMap[route.id]?.accountIds.length}) }}
              </span>

              <ng-template #accountsTooltip>
                <div class="col" style="min-width: 400px;">
                  <div class="flex layout-row">
                    <div class="flex br-caption-1" style="text-align: start;">{{'Account Name' | translate}}:</div>
                    <div class="flex br-caption-1" style="text-align: start;">{{'Address' | translate}}:</div>
                    <div class="flex-30 br-caption-1" style="text-align: start;">{{'Account External ID' | translate}}:</div>
                    <div class="flex-15 br-caption-1" style="text-align: start;">{{'Pallets' | translate}}:</div>
                  </div>

                  <div class="flex layout-row" *ngFor="let details of routeUiDataMap[route.id]?.accountsDetails">
                    <div class="flex" style="text-align: start;">
                      {{details.name}}
                    </div>

                    <div class="flex layout-align-center-center text-ellipsis" style="text-align: start;">
                      {{ details.address ? (details.address | bringozAddressCity) : '---'}}
                    </div>

                    <div class="flex-30 layout-align-center-center text-ellipsis" style="text-align: start;">
                      {{details.externalId || '---' }}
                    </div>

                    <div class="flex-15 layout-row layout-align-start-center gap-5">
                      {{details.pallets | number: '1.0-2'}}
                      <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <!-- Account External ID Column -->
            <div *ngIf="settings?.columns?.accountExternalId" class="td col-account-ext-id gap-5">
              <bringoz-icon iconName="hash"
                            classSize="sm"
                            openDelay="300">
              </bringoz-icon>
              <span *ngIf="!routeUiDataMap[route.id]?.accountExternalIds?.length" class="br-body-1 text-ellipsis">---</span>
              <app-bringoz-items-list-display *ngIf="routeUiDataMap[route.id]?.accountExternalIds?.length"
                                              [items]="routeUiDataMap[route.id]?.accountExternalIds"
                                              [maxItems]="6">
              </app-bringoz-items-list-display>
            </div>

            <div *ngIf="settings?.columns?.pickingHour" class="td col-picking-hour gap-5">
              <bringoz-icon iconName="depot" classSize="sm" openDelay="300"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ routeUiDataMap[route.id]?.pickingTime | bringozTime:'time' }}</span>
            </div>

            <div *ngIf="settings?.columns?.carrier" class="td col-carrier gap-5">
              <bringoz-icon iconName="carrier" classSize="sm"></bringoz-icon>
              <app-bringoz-state-link *ngIf="!!route.resource?.carrierReference"
                                      class="flex text-ellipsis font-weight-400"
                                      [state]="'accounts-detail-supply.info.preferences'"
                                      [permission]="'accounts.supply.get'"
                                      [params]="{id: route.resource.carrierReference.id}"
                                      [text]="route.resource.carrierReference.name"
                                      (click)="$event.stopPropagation()">
              </app-bringoz-state-link>
              <span *ngIf="!route.resource?.carrierReference" class="br-body-1 text-ellipsis">---</span>
            </div>

            <div *ngIf="settings?.columns?.skills" class="td col-skills gap-5">
              <bringoz-icon iconName="tag-outline" classSize="sm"></bringoz-icon>
              <span *ngIf="!route.resource?.allocationSkills?.length" class="br-body-1 text-ellipsis">---</span>
              <app-skill-tags *ngIf="route.resource?.allocationSkills?.length" class="flex" [skillsIds]="route.resource?.allocationSkills" limit="1"></app-skill-tags>
            </div>

            <div *ngIf="settings?.columns?.labels" class="td col-labels gap-5">
              <bringoz-icon iconName="label-outline" classSize="sm"></bringoz-icon>
              <app-bringoz-labels-display *ngIf="!!route.resource?.labels?.length" [labels]="route.resource.labels" maxItems="1"></app-bringoz-labels-display>
              <span *ngIf="!route.resource?.labels?.length" class="br-body-1 text-ellipsis">---</span>
            </div>

            <div *ngIf="settings?.columns?.income" class="td col-income gap-5">
              <bringoz-icon iconName="dollar-circle" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis route-total-income" [ngClass]="routeUiDataMap[route.id]?.totalIncomeClass">
                {{ route.totals?.totalIncome | bringozPrice: '---' }}
              </span>
            </div>

            <div *ngIf="settings?.columns?.value" class="td col-value gap-5">
              <bringoz-icon iconName="dollar-circle" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.value | bringozPrice }}</span>
            </div>

            <div *ngIf="settings?.load?.weight" class="td col-load col-load-weight gap-5">
              <bringoz-icon iconName="weight" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.totalLoad | bringozWeight:true:'---':true }}</span>
            </div>

            <div *ngIf="settings?.load?.volume" class="td col-load col-load-volume gap-5">
              <bringoz-icon iconName="volume" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.totalVolume | bringozVolume:true:'---' }}</span>
            </div>

            <div *ngIf="settings?.load?.packages" class="td col-load col-load-packages gap-5">
              <bringoz-icon iconName="package-outline" classSize="sm"></bringoz-icon>
              <span *ngIf="route.totals?.totalPackagesCount > 0; else emptyLoad" class="br-body-1 text-ellipsis">
                {{ route.totals?.totalPackagesCount }}
              </span>
            </div>

            <div *ngIf="settings?.load?.value" class="td col-load col-load-value gap-5">
              <bringoz-icon iconName="dollar-circle" classSize="sm"></bringoz-icon>
              <span class="br-body-1 text-ellipsis">{{ route.totals?.value | bringozPrice }}</span>
            </div>

            <div *ngIf="settings?.load?.pallets" class="td col-load col-load-pallets gap-5">
              <bringoz-icon iconName="pallets" classSize="sm" [ngbTooltip]="'Pallets' | translate"></bringoz-icon>
              <span *ngIf="route.totals?.totalPallets > 0; else emptyLoad" class="br-body-1 text-ellipsis">
                {{ route.totals?.totalPallets | number: '1.0-2' }}
              </span>
            </div>

            <div *ngIf="settings?.load?.spots" class="td col-load col-load-spots gap-5">
              <bringoz-icon iconName="spot" classSize="sm"></bringoz-icon>
              <span *ngIf="route.totals?.totalSpots > 0; else emptyLoad" class="br-body-1 text-ellipsis">
                {{ (route.totals?.totalSpots === 1 ? 'X_SPOT' : 'X_SPOTS') | translate: { sum: route.totals?.totalSpots } }}
              </span>
            </div>

            <ng-template #emptyLoad><span class="br-body-1">---</span></ng-template>

            <div *ngIf="settings?.capacity?.weight" class="td col-capacity col-capacity-weight gap-5">
              <bringoz-icon iconName="weight" classSize="sm"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="route.resource?.capacity?.weight; else unlimitedWeight"
                                        [value]="(route.totals.totalLoad / route.resource.capacity.weight) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="weightTooltip">
              </app-bringoz-capacity-bar>

              <ng-template #weightTooltip>
                <span [ngClass]="routeUiDataMap[route.id]?.weightSeverity">
                  {{ (route.totals.totalLoad | number: '1.0-2') + (weightUnit | translate) + ' / ' }}
                </span>
                <span *ngIf="route.resource?.capacity?.weight" [ngClass]="routeUiDataMap[route.id]?.weightSeverity">
                  {{ (route.resource.capacity.weight | number: '1.0-2') + (weightUnit | translate) + ' = ' + ((route.totals.totalLoad / route.resource.capacity.weight) * 100 | number: '1.0-2') + '%' }}
                </span>
                <span *ngIf="!route.resource?.capacity?.weight" [ngClass]="routeUiDataMap[route.id]?.weightSeverity">
                  {{'UNLIMITED' | translate}}
                </span>
              </ng-template>

              <ng-template #unlimitedWeight>
                <div [ngbTooltip]="weightTooltip" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;">{{'UNLIMITED' | translate}}</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div *ngIf="settings?.capacity?.volume" class="td col-capacity col-capacity-volume gap-5">
              <bringoz-icon iconName="volume" classSize="sm"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="routeUiDataMap[route.id]?.volumeCapacity; else unlimitedVolume"
                                        [value]="(route.totals.totalVolume / routeUiDataMap[route.id]?.volumeCapacity) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="volumeTooltip">
              </app-bringoz-capacity-bar>

              <ng-template #volumeTooltip>
                <span [ngClass]="routeUiDataMap[route.id]?.volumeSeverity">
                  {{ (route.totals.totalVolume | number: '1.0-2') + (volumeUnit | translate) + ' / ' }}
                </span>
                <span *ngIf="routeUiDataMap[route.id]?.volumeCapacity" [ngClass]="routeUiDataMap[route.id]?.volumeSeverity">
                  {{ (routeUiDataMap[route.id]?.volumeCapacity | number: '1.0-2') + (volumeUnit | translate) + ' = ' + ((route.totals.totalVolume / routeUiDataMap[route.id]?.volumeCapacity) * 100 | number: '1.0-2') + '%' }}
                </span>
                <span *ngIf="!routeUiDataMap[route.id]?.volumeCapacity" [ngClass]="routeUiDataMap[route.id]?.volumeSeverity">
                  {{'UNLIMITED' | translate}}
                </span>
              </ng-template>

              <ng-template #unlimitedVolume>
                <div [ngbTooltip]="volumeTooltip" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;">{{'UNLIMITED' | translate}}</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div *ngIf="settings?.capacity?.pallets" class="td col-capacity col-capacity-pallets gap-5">
              <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
              <app-bringoz-capacity-bar *ngIf="route.resource?.capacity?.numberOfPallets; else unlimitedPallets"
                                        [value]="(route.totals.totalPallets / route.resource.capacity.numberOfPallets) * 100"
                                        [unit]="'%'"
                                        [severityThresholds]="severityThresholds"
                                        [showValue]="true"
                                        [ngbTooltip]="palletsTooltip">
              </app-bringoz-capacity-bar>

              <ng-template #palletsTooltip>
                <span [ngClass]="routeUiDataMap[route.id]?.palletsSeverity">
                  {{ (route.totals.totalPallets | number: '1.0-2') + ' / ' }}
                </span>
                <span *ngIf="route.resource?.capacity?.numberOfPallets" [ngClass]="routeUiDataMap[route.id]?.palletsSeverity">
                  {{ (route.resource.capacity.numberOfPallets | number: '1.0-2') + ' = ' + ((route.totals.totalPallets / route.resource.capacity.numberOfPallets) * 100 | number: '1.0-2') + '%' }}
                </span>
                <span *ngIf="!route.resource?.capacity?.numberOfPallets" [ngClass]="routeUiDataMap[route.id]?.palletsSeverity">
                  {{'UNLIMITED' | translate}}
                </span>
              </ng-template>

              <ng-template #unlimitedPallets>
                <div [ngbTooltip]="palletsTooltip" class="flex layout-row layout-align-start-center gap-5">
                  <div class="unlimited-container layout-row layout-align-center-center">
                    <span class="br-caption-1 font-weight-500" style="color: #484848; font-size: 10px;">{{'UNLIMITED' | translate}}</span>
                  </div>
                  <bringoz-icon iconName="infinite"></bringoz-icon>
                </div>
              </ng-template>
            </div>

            <div class="td col-actions sticky-col sticky-col-right gap-5 drill-down-arrow full-height-arrow"
                 (click)="onDrillDown.emit({ routeId: route.id, event: $event }); $event.stopPropagation()">
              <bringoz-icon iconName="arrow-right" classSize="lg" fill="#484848"></bringoz-icon>
            </div>

          </div>
        </ng-container>

      </div>

    </div>
  </cdk-virtual-scroll-viewport>

  <!-- Custom drop animations -->
  <div *ngFor="let anim of dropAnimations"
       class="custom-drop-animation"
       [ngClass]="{'multiple-items': anim.isMultiple}"
       [style.left.px]="anim.x"
       [style.top.px]="anim.y">
    <div *ngIf="!anim.isMultiple" class="activity-item-preview">
      <div class="activity-content">
        <div class="activity-title">{{ anim.text }}</div>
        <div class="activity-subtitle">Drop complete</div>
      </div>
    </div>
    <div *ngIf="anim.isMultiple" class="multiple-items-preview">
      <span>{{ anim.count }} Jobs Added</span>
    </div>
  </div>
</div>
